module.exports = __webpack_public_path__ + "static/the-resilience-dividend-0e448c3ba45a5f3d8a7d27ce2f3f4ede.jpg";